export default __webpack_public_path__ + "static/media/google-cloud-stackdriver.77e5f4e4e7af6c4e63ffcb93b9b787af.svg";